const headerInfoSwiper = (root = document) => {
  const swiperEl = root.querySelector(".js-header-info-swiper");
  if (!swiperEl) return;

  // 二重初期化防止
  if (swiperEl.classList.contains("swiper-initialized")) return;

  new Swiper(swiperEl, {
    loop: true,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false, // 任意（途切れない運用なら推奨）
    },
    speed: 7000,
    slidesPerView: isMobile() ? "auto" : 1,
    spaceBetween: isMobile() && 100,
  });
};
